'use strict';
var ErrorUtils = require('./error-utils');

module.exports = function (opts) {
  if (!opts) { opts = []; }

  if (Array.isArray(opts)) {
    return new ErrorUtils(opts);
  } else {
    return new ErrorUtils([opts]);
  }
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonapi-serializer/lib/error.js
// module id = 1132
// module chunks = 0